import {
	Box,
	Flex,
	Text,
	Button,
	Container,
	Badge,
	Image,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const frontendUrl =
	import.meta.env.VITE_FRONTEND_URL ||
	(["localhost", "127.0.0.1"].includes(window.location.hostname)
		? "http://localhost:5173"
		: undefined);

export const Navbar: React.FC = () => {
	return (
		<Box
			bg="rgba(255,255,255,0.88)"
			borderBottom="1px"
			borderColor="gray.200"
			position="sticky"
			top={0}
			zIndex={30}
			backdropFilter="blur(10px)"
		>
			<Container maxW="container.xl">
				<Flex h={16} alignItems="center" justifyContent="space-between">
					<Flex alignItems="center" gap={3} minW={0}>
						<Image
							src="/assets/images/FlowTable-logo.svg"
							alt="FlowTable"
							h={{ base: "26px", md: "36px" }}
							w="auto"
							flexShrink={0}
						/>
						<Flex direction="column" minW={0}>
							<Text
								fontSize={{ base: "sm", md: "lg" }}
								fontWeight="800"
								color="gray.900"
								noOfLines={1}
							>
								Справка
							</Text>
							<Badge
								display={{ base: "none", md: "inline-flex" }}
								colorScheme="teal"
								variant="subtle"
								w="fit-content"
							>
								Руководство пользователя
							</Badge>
						</Flex>
					</Flex>

					<Flex alignItems="center" gap={3}>
						<Button
							as={RouterLink}
							to="/"
							display={{ base: "none", md: "inline-flex" }}
							variant="ghost"
							size="sm"
						>
							Главная
						</Button>
						{frontendUrl && (
							<Button
								as="a"
								href={frontendUrl}
								target="_blank"
								rel="noopener noreferrer"
								size="sm"
								minH="44px"
							>
								Открыть сервис
							</Button>
						)}
					</Flex>
				</Flex>
			</Container>
		</Box>
	);
};
